<template>
  <div class="row">
    <div v-if="terminal" class="col-md-12">
      <div class="card">
        <h2 class="card-header">Terminal details</h2>
        <div class="card-body">
          <h5 class="card-title">{{ terminal.name }}</h5>
          <h6 class="card-subtitle mb-4 text-muted">
            Terminal ID:
            <code>{{ terminal.id }}</code>
          </h6>

          <div class="row">
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <th>Serial number</th>
                    <td>
                      <code>{{ terminal.serialNumber }}</code>
                    </td>
                  </tr>
                  <tr>
                    <th>Custom reference</th>
                    <td>
                      <span v-if="terminal.customReference">{{ terminal.customReference }}</span>
                      <span v-else>No custom reference</span>
                      &nbsp;
                      <button
                        @click="showUpdateCustomReferenceDialog"
                        class="btn btn-sm btn-default"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>Allocated at</th>
                    <td>{{ terminal.currentAllocation.createdAt | moment('YYYY-MM-DD HH:mm A') }}</td>
                  </tr>
                  <tr>
                    <th>Allocated to</th>
                    <td>
                      <span v-if="terminal.currentAllocation.submerchantId">
                        <submerchant-fragment
                          :submerchantId="terminal.currentAllocation.submerchantId"
                          link-classes="btn btn-default"
                        ></submerchant-fragment>
                      </span>
                      <!-- TODO: support depositories -->
                      <span v-else class="text-danger">No driver allocated</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Software status</th>
                    <td>
                      <span
                        v-if="terminal.reportedConfiguration && terminal.reportedConfiguration.isUpToDate"
                        class="text-success"
                      >
                        <i class="fa fa-check"></i>&nbsp; Up to date
                      </span>
                      <span
                        v-else-if="terminal.reportedConfiguration && !terminal.reportedConfiguration.isUpToDate"
                        class="text-danger"
                      >
                        <i class="fa fa-exclamation-triangle"></i>&nbsp; Out of date
                      </span>
                      <span v-else class="text-warning">
                        <i class="fa fa-question-circle"></i>&nbsp; Status unknown
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <img
                class="img img-responsive mx-auto d-block mb-5"
                :src="`/static/img/terminals/${terminalImageFileName}`"
                style="max-height: 250px"
              />
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button v-on:click="$router.back()" class="btn btn-default">
            <i class="fa fa-arrow-left"></i>&nbsp; Go back
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="loading" class="spinner-container">
        <double-bounce size="60px"></double-bounce>
      </div>
    </div>
  </div>
</template>
  
<script>
import { DoubleBounce } from "vue-loading-spinner";
import swal from "sweetalert2";
import SubmerchantFragment from "src/components/Dashboard/Views/Pages/Submerchants/SubmerchantFragment.vue";

export default {
  name: "SalePage",
  components: {
    DoubleBounce,
    SubmerchantFragment
  },
  data() {
    return {
      error: null,
      loading: null,
      terminal: null
    };
  },
  computed: {
    terminalImageFileName() {
      if (!this.terminal) {
        return 'default.png';
      }

      if (this.terminal && this.terminal.model.includes('55')) {
        return 'bluePad55-trans.png';
      } else if (this.terminal && this.terminal.model.includes('5000')) {
        return 'bluePad5000-trans.png';
      } 
    }
  },
  props: ["terminalId"],
  beforeMount() {
    this.loading = true;
    this.axios
      .get(`/v1/terminals/${this.terminalId}`)
      .then(response => {
        this.loading = false;
        this.terminal = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = "Failed to load terminal";
      });
  },
  methods: {
    showUpdateCustomReferenceDialog() {
      swal({
        type: "question",
        title: "Enter new custom reference",
        input: "text",
        inputValue: this.terminal.customReference,
        showCancelButton: true,
        confirmButtonText: "Update",
        showLoaderOnConfirm: true,
        preConfirm: input => {
          return this.axios
            .patch(`/v1/terminals/${this.terminal.id}`, {
              customReference: input
            })
            .then(response => {
              if (response.data && response.data) {
                this.terminal = response.data;
              }
              return response;
            })
            .catch(error => {
              swal.showValidationMessage(`Update failed: ${error.message}`);
            });
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(result => {
        if (result.value) {
          swal({
            type: "success",
            title: "Custom reference updated",
            text: "Thank you."
          });
        }
      });
    }
  }
};
</script>
